import EnvType from "@/module/main/page/EnvTypeEnum";
import IEnvSettings from "@/module/main/model/applicationForm/IEnvSettings";
import Brand from "@/module/main/model/applicationForm/BrandEnum";
import FinancedSubjectType from "@/module/main/dto/FinancedSubjectTypeEnum";
import OrderType from "@/module/main/dto/OrderTypeEnum";
import EnvPreprod from "@/module/main/page/EnvPreprodEnum";
import EnvProd from "@/module/main/page/EnvProdEnum";

export default class EnvSettings implements IEnvSettings {

    envType: EnvType;
    env: string;
    username: string;
    password: string;
    isEmbedded: string;
    brand: Brand;
    financedSubjectType: FinancedSubjectType;
    orderType: OrderType;
    showQrCode: boolean;
    copyToClipboard: boolean;

    constructor(data: Partial<EnvSettings> = {})
    {
        this.envType = data.envType || EnvType.TEST;
        this.env = data.env || "cz10d1";
        this.username = data.username || "loki";
        this.password = data.password || "loki";
        this.isEmbedded = data.isEmbedded || "false"; // TODO: Refactor after completing the HcCheckbox component. Change type to boolean.
        this.brand = data.brand || Brand.HOMECREDIT;
        this.financedSubjectType = data.financedSubjectType || FinancedSubjectType.CASH;
        this.orderType = data.orderType || OrderType.STANDARD;
        this.showQrCode = data.showQrCode || false;
        this.copyToClipboard = data.copyToClipboard || false;
    }

    getEnvValue(): string {
        let envValue : string;

        switch (this.envType) {
            case EnvType.TEST:
                envValue = this.env;
                break;
            case EnvType.PREPROD:
                envValue = EnvPreprod[this.env as keyof typeof EnvPreprod];
                break;
            case EnvType.PROD:
                envValue = EnvProd[this.env as keyof typeof EnvProd];
                break;
            default:
                throw new Error(`Unknown envType: ${this.envType}`);
        }

        if (!envValue) {
            throw new Error(`Unknown key "${this.env}" for envType "${this.envType}"`);
        }

        return envValue;
    }
}
